<template>
    <div class="cash-content-box flex flex-1">
        <el-tabs v-model="tabIndex" type="card" addable
                 @tab-remove="removeOrder" @tab-add="addOrder" class="flex flex-v flex-1">
            <el-tab-pane
                    v-for="(item, index) in orderList"
                    :key="index"
                    :label="item.order_no ? item.order_no : '消费列表'+item.order_index"
                    :name="index.toString()"
                    closable
            >
                <cash-content :content="item.pro_list" @deleteProduct="deleteProduct" @updateProductList="updateProductList" />
            </el-tab-pane>
        </el-tabs>
    </div>
</template>

<script>
    import obj from "@/js/obj";
    import CashContent from "@/model/Cash/CashContent";
    export default {
        name: "CashContentBox",
        components: {CashContent},
        model: {
            prop: "orderIndex",
            event: "orderChange"
        },
        props: {
            orderList: {
                type: Array,
                default: []
            },
            orderIndex: {
                type: Number,
                default: 0
            }
        },
        data: () => ({
            tabIndex: "",
        }),
        mounted: function () {
            // obj.scrollbar(".el-tabs__content");
        },
        methods: {
            //添加新订单
            addOrder: function () {
                this.$emit("addOrder");
            },
            //移除订单
            removeOrder: function (index) {
                this.$emit("removeOrder", index);
            },
            //删除单个已选项目
            deleteProduct: function (i) {
                this.$emit("deleteProduct", i);
            },
            //更新项目列表
            updateProductList: function (newData) {
                this.$emit("updateProductList", newData);
            },
        },
        watch: {
            orderIndex: function (newData) {
                this.tabIndex = newData.toString();
            },
            tabIndex: function (newData) {
                this.$emit("orderChange", parseInt(newData));
            }
        }
    }
</script>

<style scoped>
    .el-tabs{
        width: 100%;
    }
    .cash-content-box{
        background-color: #FFFFFF;
        padding: 16px;
    }
    .el-tab-pane{
        flex: 1;
        display: flex;
        overflow: auto;
    }
</style>
<style>
    .cash-content-box .el-tabs__content{
        display: flex;
        flex-flow: column nowrap;
        flex: 1;
        overflow: auto;
    }
    .cash-content-box .el-tabs--card>.el-tabs__header{
        height: 34px;
        margin-bottom: 0px;
    }

    .cash-content-box .el-tabs--card .el-tabs__item{
        /*background-color: #FFFFFF;*/
        /*color: #606266;*/
        height: 34px;
        line-height: 33px;
    }
    .cash-content-box .el-tabs--card .el-tabs__item:first-child{
        border-top-left-radius: 3px;
    }
    .cash-content-box .el-tabs--card .el-tabs__item:last-child{
        border-top-right-radius: 3px;
    }
    /*.cash-content-box .el-tabs--card>.el-tabs__header .el-tabs__item.is-active.is-closable{*/
        /*color: #6cb1e1;*/
    /*}*/
    /*添加按钮*/
    .cash-content-box .el-tabs--card .el-tabs__new-tab{
        margin-top: 3px;
        margin-bottom: 3px;
        margin-right: 25px;
        padding: 3px;
        border: 1px solid transparent;
    }
    .cash-content-box .el-tabs--card .el-tabs__new-tab:hover{
        background-color: #f6f6f6;
    }
    .cash-content-box .el-tabs--card .el-tabs__new-tab:hover>i{
        /*color: #b2b2b2;*/
    }
    .cash-content-box .el-tabs--card .el-tabs__new-tab>i{
        color: #000000;
        font-size: 16px;
        font-weight: 400;
    }
    /*左右按钮*/
    .cash-content-box .el-tabs__nav-next, .cash-content-box .el-tabs__nav-prev{
        padding-left: 10px;
        padding-right: 10px;
        line-height: 34px;
    }
    .cash-content-box .el-tabs__nav-wrap.is-scrollable{
        padding-left: 34px;
        padding-right: 34px;
    }

    /*选择按钮*/
    .cash-content-box .el-tabs--card>.el-tabs__header .el-tabs__nav{
        border-radius: 3px 3px 0 0;
    }

    /*关闭按钮*/
    .el-tabs--card>.el-tabs__header .el-tabs__item.is-active.is-closable .el-icon-close,
    .el-tabs--card>.el-tabs__header .el-tabs__item.is-closable:hover .el-icon-close{
        width: 15px;
        height: 15px;
    }
    .cash-content-box .el-tabs--card>.el-tabs__header .el-tabs__item .el-icon-close{
        width: 15px;
        height: 15px;
        font-size: 13px;
    }
    .cash-content-box .el-tabs--card>.el-tabs__header .el-tabs__item{
        padding-left: 16px !important;
        padding-right: 16px !important;
    }
    .cash-content-box .el-tabs--card>.el-tabs__header .el-tabs__item.is-closable:hover{
        padding-left: 16px;
        padding-right: 16px;
    }
    .cash-content-box .el-tabs__item:focus.is-active.is-focus:not(:active){
        box-shadow: none;
    }
</style>
